import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const ContactInfo = () => {
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-2xl font-bold mb-6 text-white">Get in Touch</h3>
        <p className="text-lg text-[#E4E1D8] mb-8">
          We're here to answer any questions you may have about our NDIS services. Reach out and we'll respond as soon as we can.
        </p>
      </div>

      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 bg-[#0F6E56] rounded-xl flex items-center justify-center">
            <Phone className="w-6 h-6 text-white" />
          </div>
          <div>
            <h4 className="font-semibold text-white mb-1">Phone</h4>
            <a href={`tel:${mockData.companyInfo.phone.replace(/[^0-9]/g, '')}`} className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors text-lg">
              {mockData.companyInfo.phone}
            </a>
            <p className="text-[#6B6B69] text-sm mt-1">Available 24/7</p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 bg-[#0F6E56] rounded-xl flex items-center justify-center">
            <Mail className="w-6 h-6 text-white" />
          </div>
          <div>
            <h4 className="font-semibold text-white mb-1">Email</h4>
            <a href={`mailto:${mockData.companyInfo.email}`} className="text-[#E4E1D8] hover:text-[#5DCAA5] transition-colors">
              {mockData.companyInfo.email}
            </a>
            <p className="text-[#6B6B69] text-sm mt-1">We'll respond within 24 hours</p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 bg-[#0F6E56] rounded-xl flex items-center justify-center">
            <MapPin className="w-6 h-6 text-white" />
          </div>
          <div>
            <h4 className="font-semibold text-white mb-1">Location</h4>
            <p className="text-[#E4E1D8]">{mockData.companyInfo.address}</p>
            <p className="text-[#6B6B69] text-sm mt-1">Serving all of Sydney</p>
          </div>
        </div>
      </div>

      {/* Trust indicators */}
      <div className="pt-8 border-t border-[#2C2C2A]/30">
        <p className="text-sm text-[#6B6B69] mb-4">Trusted by hundreds of NDIS participants</p>
        <div className="flex items-center space-x-4">
          <div className="flex -space-x-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="w-10 h-10 rounded-full bg-[#0F6E56] border-2 border-[#2C2C2A] flex items-center justify-center text-white font-semibold text-sm">
                {i}
              </div>
            ))}
          </div>
          <div>
            <div className="flex items-center space-x-1">
              {[1, 2, 3, 4, 5].map((i) => (
                <svg key={i} className="w-5 h-5 text-[#EF9F27]" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
            <p className="text-sm text-[#6B6B69] mt-1">4.9 out of 5 stars</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;